import type { ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Logo } from './Logo.js';

const isSignedIn = (): boolean => !!localStorage.getItem('velinko_token');

export function SiteHeader(): JSX.Element {
  const signedIn = isSignedIn();
  return (
    <header className="site-header">
      <div className="site-inner site-header-row">
        <Link to="/" className="site-brand">
          <Logo size={26} />
          <span>Velinko</span>
        </Link>
        <nav className="site-nav" aria-label="Main">
          <NavLink to="/docs">Docs</NavLink>
          <NavLink to="/support">Support</NavLink>
          {signedIn ? (
            <Link to="/dashboard" className="btn btn-primary btn-sm">
              Open dashboard
            </Link>
          ) : (
            <>
              <NavLink to="/login">Sign in</NavLink>
              <Link to="/register" className="btn btn-primary btn-sm">
                Request access
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

export function SiteFooter(): JSX.Element {
  return (
    <footer className="site-footer">
      <div className="site-inner site-footer-row">
        <div className="site-footer-brand">
          <Logo size={20} />
          <span>Velinko</span>
          <span className="muted">SMS and OTP codes from your Android phone, in your browser.</span>
        </div>
        <nav className="site-footer-links" aria-label="Footer">
          <Link to="/docs">Docs</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/support">Support</Link>
          <Link to="/delete-account">Delete account</Link>
        </nav>
      </div>
    </footer>
  );
}

/** Header, content and footer for the public pages (home, docs, legal). */
export function PublicLayout({
  children,
  wide = false,
}: {
  children: ReactNode;
  wide?: boolean;
}): JSX.Element {
  return (
    <div className="site">
      <SiteHeader />
      <main className={wide ? 'site-main' : 'site-main site-inner site-narrow'}>{children}</main>
      <SiteFooter />
    </div>
  );
}
